export const bulkTestQueryKeys = {
    pageAll: (agentId: number) => ['page-bulk-tests', "agent", agentId]
} as const;
